import PropTypes, { number } from 'prop-types';

const { string, shape } = PropTypes;

// eslint-disable-next-line import/prefer-default-export
export const FieldProps = shape({
  value: number,
  label: string,
});
